import * as CONST from '../ActionTypes';
import * as util from './util';

// eslint-disable-next-line import/prefer-default-export
export const getTransactionList = (accessToken, limit, offset) => (dispatch) => fetch(
  `${process.env.REACT_APP_ENDPOINT}/api/v1/transactions/with_customer?limit=${limit}&offset=${offset}&sort=id.desc`,
  {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    mode: 'cors',
  },
)
  .then((response) => response.json())
  .then((payload) => {
    dispatch(util.actionType(CONST.GET_TRANSACTION_LIST_SUCCESS, payload));
  })
  .catch((error) => {
    dispatch(util.actionType(CONST.GET_TRANSACTION_LIST_FAILURE, error));
  });
